export default (props) => (
  <svg
    width="122"
    height="45"
    viewBox="0 0 122 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    {...props}
  >
    <path
      d="M57.0404 13.7228H45.9457C43.6773 13.7228 41.8213 15.5788 41.8213 17.8472V25.6011C41.8213 27.8695 43.6773 29.7255 45.9457 29.7255H57.0404C59.3088 29.7255 61.1648 27.8695 61.1648 25.6011V17.8472C61.1648 15.5788 59.3088 13.7228 57.0404 13.7228ZM57.494 25.6011C57.494 25.8486 57.2878 26.0548 57.0404 26.0548H45.9457C45.6982 26.0548 45.492 25.8486 45.492 25.6011V17.8472C45.492 17.5998 45.6982 17.3935 45.9457 17.3935H57.0404C57.2878 17.3935 57.494 17.5998 57.494 17.8472V25.6011Z"
      fill="black"
    />
    <path
      d="M92.799 7.90739H89.1283V13.7228H86.7773V17.3935H89.1695V17.8472V25.6011C89.1695 27.8695 91.0255 29.7255 93.2939 29.7255H99.893V26.0548H93.2939C93.0464 26.0548 92.8402 25.8486 92.8402 25.6011V17.8472V17.3935H99.9342V13.7228H92.8402V7.90739H92.799Z"
      fill="black"
    />
    <path
      d="M117.875 13.7228H106.781C104.512 13.7228 102.656 15.5788 102.656 17.8472V25.6011C102.656 27.8695 104.512 29.7255 106.781 29.7255H117.875C120.144 29.7255 122 27.8695 122 25.6011V17.8472C121.958 15.5788 120.144 13.7228 117.875 13.7228ZM118.329 25.6011C118.329 25.8486 118.123 26.0548 117.875 26.0548H106.781C106.533 26.0548 106.327 25.8486 106.327 25.6011V17.8472C106.327 17.5998 106.533 17.3935 106.781 17.3935H117.875C118.123 17.3935 118.329 17.5998 118.329 17.8472V25.6011Z"
      fill="black"
    />
    <path
      d="M80.096 13.7228H69.0014H64.877V17.8472V25.6011V35.5409H68.5477V29.6843C68.7127 29.6843 68.8364 29.7255 69.0014 29.7255H80.096C82.3644 29.7255 84.2204 27.8695 84.2204 25.6011V17.8472C84.1792 15.5788 82.3644 13.7228 80.096 13.7228ZM80.5497 25.6011C80.5497 25.8486 80.3435 26.0548 80.096 26.0548H69.0014C68.9601 26.0548 68.9189 26.0548 68.8776 26.0135H68.8364C68.6714 25.9311 68.5477 25.7661 68.5477 25.6011V17.8472C68.5477 17.641 68.6714 17.476 68.8364 17.4348H68.8776C68.9189 17.4348 68.9601 17.3935 69.0014 17.3935H80.096C80.3435 17.3935 80.5497 17.5998 80.5497 17.8472V25.6011Z"
      fill="black"
    />
    <path
      d="M11.0122 7.00002H26.0663C27.9223 7.00002 29.4483 8.52604 29.4483 10.382V25.4361H22.7255V14.5477C22.7255 14.094 22.3543 13.7228 21.9006 13.7228H11.0122V7.00002Z"
      fill="black"
    />
    <path
      d="M6.72279 28.9006V7.61868L0 14.3415V33.0663C0 34.9223 1.52603 36.4483 3.38201 36.4483H22.1068L28.8296 29.7255H7.54767C7.09398 29.7255 6.72279 29.3543 6.72279 28.9006Z"
      fill="black"
    />
  </svg>
)
